/** 收银相关权限（checkbox：1 开 / 0 关；`payment` 展示时 5 视为勾选，保存时 1→5） */
export const PERMISSION_PAYMENT_ITEMS = [
    { key: 'open_drawer', labelKey: 'staff_permission_page_bill_detector_permission' },
    { key: 'trans_table', labelKey: 'staff_permission_page_turntable_permission' },
    { key: 'merge_table', labelKey: 'staff_permission_page_merge_table_permission' },
    { key: 'print_prestatement', labelKey: 'staff_permission_page_print_the_pre_statement_permission' },
    { key: 'edit_order', labelKey: 'staff_permission_page_edit_tables_or_edit_orders_permission' },
    { key: 'cancellation_order', labelKey: 'staff_permission_page_cancellation_order' },
    { key: 'void_item', labelKey: 'staff_permission_page_return_dishes_permission' },
    { key: 'reprice', labelKey: 'staff_permission_page_repricing_permission' },
    { key: 'payment', labelKey: 'staff_permission_page_cashier_permission' },
    { key: 'authority_1', labelKey: 'menu_and_dishes_page_has_discount' },
    { key: 'is_round', labelKey: 'staff_permission_page_do_not_count_the_small_change_permission' },
    { key: 'edit_check', labelKey: 'staff_permission_page_anti_settlement_permission' },
    { key: 'dish_change_table', labelKey: 'staff_permission_page_dish_change_table' },
    { key: 'table_price_view', labelKey: 'staff_permission_page_table_price_view' },
    { key: 'table_num_view', labelKey: 'staff_permission_page_table_num_view' },
] as const;

/** 经理权限功能 */
export const PERMISSION_MANAGER_ITEMS = [
    { key: 'unpayment_view', labelKey: 'staff_permission_page_view_outstanding_orders_permission' },
    { key: 'authority_3', labelKey: 'staff_permission_page_check_the_statement' },
    { key: 'datail_view', labelKey: 'staff_permission_page_view_payment_details_permission' },
    { key: 'return_view', labelKey: 'staff_permission_page_check_return_details_permission' },
    { key: 'critical_view', labelKey: 'staff_permission_page_critical_view' },
    { key: 'dishes_view', labelKey: 'staff_permission_page_show_dish_analyze_permission' },
    { key: 'daily_view', labelKey: 'staff_permission_page_show_daily_view' },
    { key: 'shift', labelKey: 'staff_permission_page_relief_of_a_shift' },
    { key: 'print_sale', labelKey: 'staff_permission_page_print_sales_summary_permission' },
    { key: 'his_order_view', labelKey: 'staff_permission_page_viewing_historical_orders_permission' },
    { key: 'employee_sales_view', labelKey: 'staff_permission_page_viewing_employee_anlyze_permission' },
] as const;

/** 后台功能权限（含 extensions：UI 与 API 取值与 RBP 一致做翻转） */
export const PERMISSION_BACKSTAGE_ITEMS = [
    { key: 'open_config', labelKey: 'staff_permission_page_go_to_background_permission' },
    { key: 'open_employee_info', labelKey: 'staff_permission_page_setting_employee_information_permission' },
    { key: 'open_employee_class', labelKey: 'staff_permission_page_operation_permission_setting' },
    { key: 'open_menu_item', labelKey: 'staff_permission_page_setup_menu_permission' },
    { key: 'extensions', labelKey: 'staff_permission_page_tools_and_extension_features_permission' },
    { key: 'sign_record_view', labelKey: 'staff_permission_page_view_sign_record_permission' },
    { key: 'sign_record_download', labelKey: 'staff_permission_page_download_sign_record_permission' },
] as const;
